import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Trans, useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { EffectFade, Navigation, Autoplay } from "swiper/modules"; // No Pagination now
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import { Box, IconButton, useMediaQuery } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import "@styles/components/ui/FadeSwiper.scss";
import { useNavigate } from "react-router-dom";
import { gaEvent } from "@utils/gaEvent";

const FadeSwiper = ({ slides }) => {
  const { t, i18n } = useTranslation();
  const isChinese = i18n.language === "hk";
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const isPad = useMediaQuery("(max-width:768px)");
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0); // 👈 Add active index
  const memberInfoData = useSelector(
    (state) => state.memberInfo.memberInfoData
  );
  useEffect(() => {
    if (
      swiperRef.current &&
      prevRef.current &&
      nextRef.current &&
      swiperRef.current.params
    ) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <div className="fade-swiper-wrapper">
      <Swiper
        modules={[EffectFade, Autoplay, Navigation]}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        loop={true}
        speed={1000}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={(swiper) => {
          setActiveIndex(swiper.realIndex); // 👈 每次換頁更新 Index
        }}
      >
        {/* {!memberInfoData && (
          <Box
            onClick={() => {
              navigate("/member_zone");
            }}
          >
            <img
              className="join-clubs-button"
              src={
                isChinese
                  ? `${process.env.PUBLIC_URL}/assets/images/home/join_button_hk.png`
                  : `${process.env.PUBLIC_URL}/assets/images/home/join_button_hk_en.png`
              }
              alt="join now"
            ></img>
          </Box>
        )} */}
        {slides.map((item, index) => (
          <SwiperSlide key={index}>
            {item.join_btn === 1 && (
              <Box
                onClick={() => {
                  gaEvent(
                    "clubs_homepage",
                    "join_clubs",
                    "join_clubs_button_1"
                  );
                  navigate("/member_zone");
                }}
              >
                <img
                  className="join-clubs-button"
                  src={
                    isChinese
                      ? `${process.env.PUBLIC_URL}/assets/images/home/join_button_hk.png`
                      : `${process.env.PUBLIC_URL}/assets/images/home/join_button_hk_en.png`
                  }
                  alt="join now"
                ></img>
              </Box>
            )}
            {item.url ? (
              <a
                href={item.url}
                onClick={(e) => {
                  e.preventDefault(); // ⛔ 阻止即刻跳頁

                  gaEvent("clubs_homepage", "slider_bar", "slider", item.id);

                  // ✅ 給 GA 一點時間送出（配合 beacon）
                  setTimeout(() => {
                    window.location.href = item.url;
                  }, 1000); // 80–200ms
                }}
              >
                <img
                  //src={`${process.env.PUBLIC_URL}${slide.imageUrl}`}
                  src={isPad ? item.image_mobile : item.image_desktop}
                  alt={item.content}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </a>
            ) : (
              <img
                //src={`${process.env.PUBLIC_URL}${slide.imageUrl}`}
                src={isPad ? item.image_mobile : item.image_desktop}
                alt={item.content}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Prev/Next 按鈕 */}
      <IconButton ref={prevRef} disableRipple className="prev-button">
        <ArrowBackIosNewIcon />
      </IconButton>
      <IconButton ref={nextRef} disableRipple className="next-button">
        <ArrowForwardIosIcon />
      </IconButton>

      {/* 自訂 Pagination with HorizontalRuleIcon */}
      {/* <Box className="pagination-container">
        {slides.map((_, index) => (
          <HorizontalRuleIcon
            key={index}
            onClick={() => swiperRef.current.slideToLoop(index)}
            style={{
              color: activeIndex === index ? "#ed9f3f" : "#fff",
            }}
          />
        ))}
      </Box> */}
    </div>
  );
};

export default FadeSwiper;
